import { SessionService } from './SessionService'
import { DapiSuccessPayload, Card } from '../types'

export const CARD_HUB_URL = '/acs/v1/cards/debit'

export type SuccessPayload = DapiSuccessPayload<{ cardDetail: Card }>

type QueryCardDetail = (params: { custCardId: string }) => Promise<Card>

export const queryCardDetail: QueryCardDetail = async ({ custCardId }) => {
  const { cif, token } = await SessionService.getData()

  const response = await fetch(`${CARD_HUB_URL}/${custCardId}`, {
    method: 'GET',
    headers: {
      cif: cif.toString(),
      'Content-type': 'application/json',
      Accept: 'application/json',
      authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) throw new Error()

  const { cardDetail } = (await response.json()) as SuccessPayload

  return cardDetail
}
